<button type="button" class="template {{ template.id }}" (click)="addRow()" matTooltip="{{ template.tooltip }}" matTooltipPosition="above">
    <span><span *ngFor="let i of counter(template.nbElements)" class="col"></span></span>
</button>